export default __webpack_public_path__ + "simple-map-500-fa3fe393f2c7140c0fbea5e81df39306.webp";